window.userfunctions = {
    key: "hasVisited",
    userIsNewVisitor: function(name) {
        // First visit = no key set
        const hasVisited = localStorage.getItem(window.userfunctions.key);

        if (!hasVisited) {
            return true; // New visitor
        }
        return false; // Returning visitor
    },
    setNewVisitorFlag: function(name) {
        // Mark that they’ve now visited
        localStorage.setItem(window.userfunctions.key, "true");
    }
}
